import { create } from 'zustand';
import type { ActivitySearchMode } from './shared';

type ActivitySearchModeStore = {
    mode: ActivitySearchMode;
    /**
     * Switch search mode (writes `?mode=` via nuqs). Wired by `ActivitySearchModeBridge`
     * after mount; safe to call from filters, empty states, etc.
     */
    setMode: (mode: ActivitySearchMode) => void;
};

export const useActivitySearchModeStore = create<ActivitySearchModeStore>(() => ({
    mode: 'normal',
    setMode: () => {
        /* replaced by ActivitySearchModeBridge */
    },
}));
